<template>
  <div class="slide-box">
    <swiper
      :options="swiperOption"
      ref="mySwiper"
    >

      <!-- swiper-item -->
      <swiper-slide>
        <div class="wrap">
          <div class="context">
            <h1><span class="light">星原</span>统计服务</h1>
            <h2>调查值得<span class="light">信赖</span>，服务让人<span class="light">满意</span></h2>
            <button @click="handleToAboutUs">更多</button>
          </div>
          <div class="img"><img src="@/assets/images/home/slide-picture/bg-peo.png"></div>
        </div>
        <div class="img-bg"><img src="@/assets/images/home/slide-picture/bg.png"></div>
      </swiper-slide>

      <!-- dots -->
      <div
        class="swiper-pagination"
        slot="pagination"
      ></div>
    </swiper>
  </div>
</template>

<script>
import {
  swiper,
  swiperSlide
} from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import SmartParkPng from '@/assets/images/home/slide-picture/smart-park.png'
export default {
  name: 'SlidePicture',
  data () {
    return {
      imgs: [SmartParkPng],
      swiperOption: {
        loop: true,
        loopFillGroupWithBlank: true,
        speed: 1500,
        // autoplay: {
        //   delay: 5000,
        //   disableOnInteraction: false,
        //   waitForTransition: true
        // },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper
    }
  },
  mounted () {
    this.swiper.slideTo(1, 1000, false)
  },
  methods: {
    handleToAboutUs () {
      this.$router.push('/about-us')
    }
  },
  components: {
    swiper,
    swiperSlide
  }
}
</script>

<style lang="less" scoped>
.slide-box {
  display: flex;
  justify-content: center;

  .swiper-container {
    height: 100%;

    .swiper-slide {
      display: flex;
      justify-content: center;
      position: relative;

      .wrap {
        display: flex;
        justify-content: space-between;
        position: relative;

        .context {
          margin-left: 16px;
          align-self: center;

          .light {
            color: #375ff1;
          }

          h1 {
            margin-top: 0;
            font-size: 48px;
            color: #333;
          }

          h2 {
            margin: 0;
            font-size: 38px;
          }

          h1,
          h2 {
            margin-bottom: 24px;
            line-height: 100%;
          }

          p {
            color: #6b798e;
            font-size: 16px;
            margin-bottom: 50px;
          }

          button {
            width: 100px;
            height: 38px;
            color: #543832;
            font-size: 14px;
            border-radius: 25px;
            border: none;
            outline: none;
            cursor: pointer;
            background: -webkit-linear-gradient(left, #ffce86, #ffbd76);
            /* Safari 5.1 to 6.0 */
            background: -o-linear-gradient(left, #ffce86, #ffbd76);
            /* Opera 11.1 to 12.0 */
            background: -moz-linear-gradient(left, #ffce86, #ffbd76);
            /* Firefox 3.6 to 15 */
            background: linear-gradient(to left, #ffce86, #ffbd76);
          }
        }

        .img {
          margin-top: 36px;
          width: 480px;
          height: 418px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .img-bg {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: -99;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .smart-park-slide {
      background-color: #07062e;

      .wrap {
        height: 439px;
        background: url("~@/assets/images/home/slide-picture/smart-park.png")
          center bottom no-repeat;
        background-size: auto 100%;
        text-align: center;
        color: white;

        .context {
          margin: 0 auto;
          color: white;
          align-self: top;

          h1 {
            color: #375ff1;
          }

          p {
            color: white;
          }
        }
      }
    }
  }
}
</style>